import { CardKind, Cell, Command, Commands, Offer } from "@highmarch/domain";

/**
 * PLACE (or a second tap on the chosen spot): the one command for the card in hand — the shown road option, the tower
 * on its chosen spot, the upgrade on its chosen tower, a skill card learned — or null when there is nothing to confirm yet. The card is read
 * once, before anything runs: building a tower closes the offer, and reading the picked card after that threw on every
 * tower built (REVIEW §4).
 */
export function placeCommand(offer: Offer | null, ghostIndex: number, towerSpot: Cell | null, upgradeTarget: number, moveFrom = -1): Command | null {
  if (offer === null || !offer.hasPick) return null;
  switch (offer.pickedCard.kind) {
    case CardKind.Path: return Commands.placeSegment(ghostIndex);
    case CardKind.Tower: return towerSpot === null ? null : Commands.placeTower(towerSpot.x, towerSpot.y);
    case CardKind.Upgrade: return upgradeTarget < 0 ? null : Commands.upgradeTower(upgradeTarget);
    // M55: the Move card needs its tower and its new square
    case CardKind.Move: return moveFrom < 0 || towerSpot === null ? null : Commands.moveTower(moveFrom, towerSpot.x, towerSpot.y);
    // Tier 4: LEARN spends a skill card; an Ascend card is spent by the branch picker (chooseBranch), not PLACE.
    case CardKind.Skill: return Commands.learnSkill();
    default: return null;
  }
}
